module.exports = __webpack_public_path__ + "assets/img/game-btn.442d6ebf.png";